<div class="shiping-details">
    <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-4">
            <div class="section-container">{{ "orderCheckOut.shipToAddress" | cxTranslate }} <span class="selected">
                <span class="sel" *ngIf="!userAddressData?.quoteCartType">{{ "orderCheckOut.selected" | cxTranslate }}</span></span></div>

                <address>
                    <div>
                        {{selectedAddress?.firstName}}
                        {{selectedAddress?.lastName}}
                    </div>
                    <div>{{selectedAddress?.companyName}}</div>
                    <div>{{selectedAddress?.line1}}{{selectedAddress?.line1 ? "," : " "}}
                        {{selectedAddress?.line2}}{{selectedAddress?.line2 ? "," : " "}}<br></div>
                    <div>{{selectedAddress?.town}}{{selectedAddress?.town ? "," : " "}}</div>
                    {{selectedAddress?.region?.name}}{{selectedAddress?.region?.name ? "," : " "}}
                    <div> {{selectedAddress?.country?.name}}{{selectedAddress?.country?.name ? "," : " "}}
                        {{ selectedAddress?.postalCode }}</div>
                </address>
                <div class="ter-btn-holder" *ngIf="!isSelectAddress"><button class="vs-tertiary-btn"
                  (click)="selectAddress()">{{ "orderCheckOut.selectAnotherAddBtn" | cxTranslate }}</button>
                </div>
        </div>


        <div class="col-md-8 col-lg-8 col-sm-8 fl_right">
            <vs-address
            (reciveShipToAddress)="selectedAdd($event)"
            (closeShipAdd)="closeForm($event)"

            *ngIf="isSelectAddress"
              [componentAddress]="componentAddress"
              [isCommissionEligible]='userAddressData?.isCommissionEligible'
              [cartName]='cartName'
             ></vs-address>
        </div>
    </div>
</div>
